import React from 'react';

// ANTD
import Button from 'antd/lib/button';

// STATE
import { useGlobalState } from '../../index';

// STYLES
import './styles.scss';

// UTILS
import { formatAddress } from '../../utils/format-address';

// ADDRESSES
import { addressList } from './address-list';

function Header() {

    const [state, dispatch] = useGlobalState();

    const connectWallet = async (): Promise<void> => {
        if (state.chainId === parseInt(process.env.REACT_APP_NETWORK_ID as string)) {

            const accounts = await window.ethereum?.request({
                method: "eth_requestAccounts",
            });

            if (accounts?.length) {
                dispatch({ user: accounts[0], connected: true });
            }

        } else {
            switchNetwork();
        }
    };

    const switchNetwork = async (): Promise<void> => {
        await window.ethereum?.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: `0x${process.env.REACT_APP_NETWORK_ID as string}` }],
        });
    };

    const checkAddressExist = (address: string): boolean => {
        const addressFound = addressList.find((addressItem: string) => address.toLowerCase() === addressItem.toLowerCase());
        if(addressFound) return true;
        return false;
    };

    return (
        <div className="header-container">
            <div className="header-content">
                <a href="/">
                    <img src="../../assets/img/logo_dark.png" width="111px" alt="UNXD Logo" />
                </a>
                <ul>
                    <li><a href="https://unxd.com/drops">Drops</a></li>
                    <li><a href="https://unxd.com/marketplace">Marketplace</a></li>
                </ul>
                <div></div>
                {state.user && checkAddressExist(state.user) ? (
                    state.connected ? 
                        <div className="user-state-container">
                            <Button type="primary" shape="round" className="connected">{formatAddress(state.user)}</Button>
                        </div>
                    : <Button type="primary" shape="round" className="connect" onClick={() => connectWallet()}>Connect wallet</Button>
                ) : null}
            </div>
        </div>
    );

}

export default Header;